import { Alert, Button, Dialog, DialogActions, DialogContent, DialogContentText, DialogTitle } from '@mui/material';
import DeleteIcon from '@mui/icons-material/Delete';

export interface DeleteTripDialogProps {
    open: boolean;
    trip: { id: string; name?: string | null } | null;
    error: string | null;
    onConfirm: () => void;
    onClose: () => void;
}

export default function DeleteTripDialog({ open, trip, error, onConfirm, onClose }: DeleteTripDialogProps) {
    return (
        <Dialog open={open} onClose={onClose}>
            <DialogTitle>Delete trip</DialogTitle>
            <DialogContent>
                <DialogContentText>
                    Are you sure you want to delete &quot;{trip?.name ?? 'this trip'}&quot;? This cannot be undone.
                </DialogContentText>
                {error && (
                    <Alert severity="error" sx={{ mt: 2 }}>
                        {error}
                    </Alert>
                )}
            </DialogContent>
            <DialogActions>
                <Button onClick={onClose}>Cancel</Button>
                <Button color="error" variant="contained" startIcon={<DeleteIcon />} onClick={onConfirm}>
                    Delete
                </Button>
            </DialogActions>
        </Dialog>
    );
}
